import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Progress } from "antd";
import CardHeader from "../../../components/atoms/cardHeader";
import { customRatingThunk } from "../../../store/thunks/dashboardThunk";
import AllToolTip from "../../../components/atoms/Tooltip/AllToolTips";

const CustomerRating = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.dashboardRating || {});

  useEffect(() => {
    dispatch(customRatingThunk());
  }, []);

  return (
    <div className="card card-custom h-100">
      <div className="bg-gray-700 border-1 border-bottom card-header min-h-auto py-3">
        <h4
          className="card-label font-weight-bold text-white"
          style={{ margin: " 7px 0" }}
        >
          Customer Rating
          <AllToolTip text="Average rating given by customers based on their reviews." />
        </h4>
      </div>
      <div className="card-body">
        {data?.ratings.map((item, index) => (
          <div className="align-items-center d-flex w-100 mb-3" key={index}>
            <span className="font-size-lg font-weight-bolder text-dark col-1 p-0">
              {item.star} Star
            </span>
            <div className="w-100 col-9">
              <Progress
                className="five_rating"
                showInfo={false}
                percent={item.percent || 0}
              />
            </div>
            <span className="font-size-lg font-weight-bolder text-dark col-2 p-0">
              {item.userCount}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerRating;
